/* Rhino Spice v7.4.3: AJAX add-to-cart for custom blend cards.
   Uses Shopify section rendering and native Dawn cart drawer; no price calculations here. */
(function () {
  document.addEventListener('submit', async function (event) {
    const form = event.target.closest('form.rhino254-product-form');
    if (!form) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return; // native submit fallback
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (button && button.disabled) return;
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    try {
      const data = new FormData(form);
      data.append('sections', drawer.getSectionsToRender().map(s => s.id).join(','));
      data.append('sections_url', window.location.pathname);
      const base = window.Shopify?.routes?.root || '/';
      const response = await fetch(base + 'cart/add.js', {
        method: 'POST', body: data, headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add to cart');
      drawer.setActiveElement(document.activeElement);
      await drawer.renderContents(result);
    } catch (error) {
      alert(error.message || 'Unable to add this item. Please try again.');
    } finally {
      if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
    }
  }, true);
})();
